/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuccessList = {
    type: 'array',
    contains: {
        type: 'Success',
    },
} as const;
